import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import StreamQualitySummary from './StreamQualitySummary';

import type { Stream } from 'src/services/LeadStreamsService/agent';

export default function StreamAiTraining({ stream }: { stream: Stream }) {
    return (
        <Box sx={{ borderTop: '1px solid var(--lm-border)', pt: 2.5 }}>
            <Typography component="h3" sx={{ fontSize: 17, fontWeight: 700, mb: 1.5 }}>
                Обучение на ваших оценках
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between" gap={2}>
                <Typography sx={{ color: 'var(--lm-muted)', fontSize: 14 }}>
                    Оцените реальные лиды этого потока: «Да», если подходит, «Нет», если не подходит. ИИ учтёт ваши оценки при отборе.
                </Typography>
                <Button component={Link} to={`/feed?stream=${stream.id}&training=1`} variant="outlined" sx={{ flexShrink: 0, textTransform: 'none' }}>
                    Обучить ИИ на реальных лидах
                </Button>
            </Stack>
            <StreamQualitySummary streamId={stream.id} />
        </Box>
    );
}
